import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* Opening Lead - The Moment of Doubt */}
      <Section background="cream" className="text-center" data-id="element-144">
        <div className="max-w-2xl mx-auto space-y-4" data-id="element-145">
          <h2 className="text-3xl md:text-4xl" data-id="element-146">
            Hay un momento que casi nadie admite.
          </h2>

          <div className="space-y-3 text-lg text-gray-700 leading-relaxed" data-id="element-147">
            <p data-id="element-148">No es cuando te duele la garganta.</p>
            <p data-id="element-149">No es cuando te cae pesado lo que comiste.</p>
            <p data-id="element-150">No es cuando te pica la piel.</p>
            <p className="font-serif text-2xl font-bold text-[#1B4332] py-2" data-id="element-151">
              Es el segundo después.
            </p>
            <p data-id="element-152">Ese segundo en el que pensás:</p>
            <p className="italic font-medium text-[#1B4332]" data-id="element-153">
              "¿Esto es una pavada… o me tengo que preocupar?"
            </p>
          </div>

          <div className="bg-white p-5 rounded-xl shadow-sm border border-[#1B4332]/10 my-5" data-id="element-154">
            <p className="text-gray-600 mb-3" data-id="element-155">
              Y ahí hacés lo que hacemos todos: abrís el celular.
            </p>
            <ul className="space-y-2 text-left max-w-md mx-auto" data-id="element-156">
              <li className="flex items-center gap-3" data-id="element-157">
                <span className="w-1.5 h-1.5 rounded-full bg-[#EF4444]" data-id="element-158" />
                <span data-id="element-159">Google te tira 40 respuestas opuestas.</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-160">
                <span className="w-1.5 h-1.5 rounded-full bg-[#EF4444]" data-id="element-161" />
                <span data-id="element-162">Un video viral te promete curas mágicas.</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-163">
                <span className="w-1.5 h-1.5 rounded-full bg-[#EF4444]" data-id="element-164" />
                <span data-id="element-165">Terminás peor: sin alivio y con miedo.</span>
              </li>
            </ul>
          </div>

          <p className="text-xl font-medium text-[#1B4332]" data-id="element-166">
            Este ebook existe para ese momento.
          </p>
        </div>
      </Section>

      {/* The Real Problem */}
      <Section background="white" data-id="element-167">
        <div className="max-w-2xl mx-auto" data-id="element-168">
          <div className="inline-flex items-center gap-2 text-[#C9963A] font-bold uppercase tracking-wider text-sm mb-3" data-id="element-169">
            <AlertCircle className="w-5 h-5" data-id="element-170" />
            La verdad incómoda
          </div>
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-171">
            El problema real no es el síntoma. Es la duda.
          </h2>
          <p className="text-lg text-gray-700 mb-4" data-id="element-172">
            El síntoma molesta. Pero lo que te desordena por dentro es no saber
            qué hacer y no saber cuándo preocuparte.
          </p>
          <p className="text-gray-600 mb-3" data-id="element-173">Esa incertidumbre te roba:</p>
          <ul className="space-y-2 mb-5" data-id="element-174">
            {['Tranquilidad', 'Sueño', 'Foco', 'Dinero (compras cosas al azar)'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-175">
                <span className="text-[#C9963A] text-xl" data-id="element-176">•</span> {item}
              </li>)}
          </ul>
          <div className="p-3 bg-[#FDF8F0] border-l-4 border-[#1B4332] rounded-r-lg" data-id="element-177">
            <p className="font-serif font-bold text-[#1B4332] text-lg" data-id="element-178">
              Este botiquín te devuelve algo básico: Criterio.
            </p>
          </div>
        </div>
      </Section>
    </>;
}